<template>
  <div class="phone-input-container">
    <input
      type="tel"
      ref="phoneInput"
      @input="onPhoneInput"
      placeholder="saisir votre numéro"
    />
    <p v-if="message" :style="{ color: messageColor, marginTop: '5px' }">
      <span v-html="message"></span>
    </p>
  </div>
</template>

<script>
import intlTelInputfr from "intl-tel-input/build/js/i18n/fr/index.js";
import intlTelInput from "intl-tel-input/build/js/intlTelInputWithUtils.js";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  name: "PhoneInput",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      iti: null,
      message: "",
      messageColor: "red",
    };
  },
  mounted() {
    this.iti = intlTelInput(this.$refs.phoneInput, {
      initialCountry: "auto",
      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json/")
          .then((res) => res.json())
          .then((data) => callback(data.country_code))
          .catch(() => callback("fr"));
      },
      i18n: intlTelInputfr, // 👈 Charge le pack de langue FR
      countryOrder: ["fr", "be", "gb", "lu", "nl", "de", "it", "es", "pt"],
      separateDialCode: true,
      nationalMode: false,
      formatOnDisplay: true,
      strictMode: true,
      placeholderNumberType: "MOBILE",
      validationNumberTypes: ["MOBILE"],
      //utilsScript: require("intl-tel-input/build/js/utils.js"),
      // utilsScript:
      //   "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
    });

    // Si une valeur est déjà passée en props
    if (this.value) {
      this.iti.setNumber(this.value);
    }

    // Écoute du changement de pays
    this.$refs.phoneInput.addEventListener("countrychange", () => {
      this.$refs.phoneInput.value = ""; // vide le champ
      this.$emit("input", ""); // met à jour le v-model
      this.clearMessage(); // vide le message
    });
  },
  methods: {
    onPhoneInput() {
      // met à jour v-model en temps réel
      const number = this.getNumber(); //this.$refs.phoneInput.value;
      this.$emit("input", number); // met à jour le v-model
      // Réinitialiser le message de validation à chaque saisie
      this.message = "";
    },
    getNumber() {
      if (this.iti.isValidNumber()) {
        return this.iti.getNumber(); // format international
      }
      return null;
    },
    validate() {
      const valid = this.iti.isValidNumberPrecise();
      if (valid) {
        this.message = "Numéro mobile/GSM valide ✅" + this.getNumber();
        this.messageColor = "green";
      } else {
        const errorCode = this.iti.getValidationError();
        this.message =
          "Numéro mobile/GSM <strong>" +
          this.getErrorMessage(errorCode) +
          "</strong> ❌ : ";
        this.messageColor = "red";
      }
      return valid;
    },
    getErrorMessage(errorCode) {
      const errorMessages = {
        0: "invalide",
        1: "Code pays invalide",
        2: "trop court",
        3: "trop long",
        4: "invalide",
      };
      return errorMessages[errorCode] || "invalide";
    },
    clearMessage() {
      this.message = "";
    },
  },
};
</script>
<style scoped>
.phone-input-container {
  max-width: 400px;
  margin: 20px auto;
  font-family: Arial, sans-serif;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

input[type="tel"] {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  margin-top: 15px;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

button:hover {
  background-color: #45a049;
}

.validation-message {
  margin-top: 10px;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
}
</style>

/* Styles globaux pour intl-tel-input - à ajouter dans votre fichier CSS global
*/
<style>
.iti {
  width: 100%;
}

.iti__flag-container {
  z-index: 10;
}
</style>
